import React, { useContext } from 'react'
import { CommonInput, CustomSelect } from 'components'
import { FaList, FaRegTrashCan } from 'react-icons/fa6';
import { PiListPlusBold } from 'react-icons/pi';
import { UserContext } from 'context';
import moment from 'moment';
import Loading from 'pages/Loading';
import { utils } from 'helper';
import { RxCross2 } from 'react-icons/rx';
import { SortingFilter } from '..';
import { BsChevronDown } from 'react-icons/bs';

const BillRaiseDetailsLrList = (props) => {

    let { loading, deleteItemHandler = () => { }, format, setFormats = () => { }, isTableToggle, setIsTableToggle = () => { }, detailsData, templateStatus, setTemplateStatus, stateStatus, setStateStatus, lrTemplateList, checkedBillRaiseLr, listCheckboxHandle = () => { }, handleDeleteListCheckbox, searchFilterInvoice, currentPage, totalPages, totalRecords, onPageChange, itemsPerPage, searchSelectedLR, setSearchSelectedLR, searchSelectedLrForDelete, setCurrentPage = () => { }, addPodHandler = () => { }, editPodHandler = () => { }, lrDetailsAndEditModalHandler = () => { }, setHandleRowData = () => { }, setShowVehicleDetails = () => { } } = props;
    const { masterData, states, setIsMaterialIndex, invoiceBillRaiseData, setInvoiceBillRaiseData, invoiceTableToggle, setInvoiceTableToggle } = useContext(UserContext)

    const startRow = (currentPage - 1) * itemsPerPage + 1;
    const endRow = Math.min(currentPage * itemsPerPage, totalRecords);

    const renderPagination = () => {
        const paginationRange = 2; // Number of pages to show around the current page
        let startPage = Math.max(1, currentPage - paginationRange);
        let endPage = Math.min(totalPages, currentPage + paginationRange);

        if (currentPage <= paginationRange) {
            endPage = Math.min(totalPages, paginationRange * 2 + 1);
        }

        if (currentPage > totalPages - paginationRange) {
            startPage = Math.max(1, totalPages - paginationRange * 2);
        }

        const pages = [];
        for (let page = startPage; page <= endPage; page++) {
            pages.push(
                <button
                    key={page}
                    className={
                        currentPage === page ? "_paginateBtn active" : "_paginateBtn"
                    }
                    // style={{ background: currentPage === page ? 'blue' : '' }}
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </button>
            );
        }

        return pages;
    };

    return (
        <>
            <div className='_billRaise_dataTable __nwBillRaiseTable mt-3'>
                {/* {renderUiStepers()}
                {showingDropdownFilters()} */}
                <div className='datagrid-table' style={{ flex: 1, maxHeight: 'none' }}>
                    {
                        loading ?
                            <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }} >
                                <Loading />
                            </div>
                            :
                            <table className='simple-table'>
                                <thead>
                                    <tr>
                                        <th style={{ width: '2%' }}></th>
                                        <th>LR Detail</th>
                                        <th>LR Date</th>
                                        <th>From To Location</th>
                                        <th>Invoice Details</th>
                                        <th>POD Status</th>
                                        <th style={{ width: '12%' }}>Freight</th>
                                        <th>Hault Time</th>
                                        <th>Item Details</th>
                                        <th>Vehicle Details</th>
                                        <th>Indent Details</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {detailsData?.length > 0 ?
                                        detailsData?.map((item, indx) => {
                                            return (
                                                <tr key={item?._id} onClick={(e) => lrDetailsAndEditModalHandler(item)}>
                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        <div className="__lrdActions_nxs">
                                                            <span
                                                                className="_del_lrM_btn _avPointer"
                                                                onClick={(e) =>
                                                                    deleteItemHandler(item?.originalData)
                                                                }
                                                            >
                                                                <FaRegTrashCan className="del_lrCion" />
                                                                <span>Delete</span>
                                                            </span>
                                                            <div className="__prtLr_bxs" >
                                                                <button type="button" className="btn anime-btn " data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <div className="__prtInx">Print <BsChevronDown /></div>
                                                                </button>

                                                                <ul className='dropdown-menu '>
                                                                    <li className='' onClick={() => setFormats({ ...format, lr_with_pod: 0, lr_id: item?.originalData?._id, originalData: item?.originalData })}>LR Print</li>
                                                                    <li className='' onClick={() => setFormats({ ...format, lr_with_pod: 1, lr_id: item?.originalData?._id, originalData: item?.originalData })}>LR + POD Print</li>
                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            <div className='_dateNtime'>
                                                                <span className='_tblText _lrNums' onClick={(e) => lrDetailsAndEditModalHandler(item)}> <a className='_avPointer'> {item?.lr_number ? item?.lr_number : '-'} </a> </span>
                                                                <span className='_lgtText'>LR Number</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.mlr_number ? item?.mlr_number : '-'}</span>
                                                                <span className='_lgtText'>MLR Number</span>
                                                            </div>

                                                            <div className='_dateNtime' onClick={(e) => e.stopPropagation()}>
                                                                <span className='_tblText _lrNums'>
                                                                    <a href={`/trip/addtrip/dispatched/${item?.trip_id?._id}`} target="_blank">
                                                                        {item?.trip_number ? item?.trip_number : '-'}
                                                                    </a>
                                                                </span>
                                                                <span className='_lgtText'>TRIP Number</span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.invoice_date ? moment(item?.invoice_date).format('DD MMM YYYY') : '-'}</span>
                                                                <span className='_lgtText'>Start Date</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.dispatch_date ? moment(item?.dispatch_date).format('DD MMM YYYY') : '-'}</span>
                                                                <span className='_lgtText'>Dispatched</span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            {/* <div className='_tblText _oneLine_tx'>
                                                                {item?.consignor_id?.name ? item?.consignor_id?.name : '-'}
                                                            </div> */}
                                                            <div className='_tblText _oneLine_tx' onClick={(e) => e.stopPropagation()}>
                                                                <a href={`/account/consignor/details/${item?.consignor_id?._id}`} target='_blank'>
                                                                    {item?.consignor_id?.name ? item?.consignor_id?.name : '-'}
                                                                </a>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.from_location ? item?.from_location : '-'} {item?.from_state ? item?.from_state : ''}</span>
                                                                <span className='_lgtText'> {item?.unit_id?.code} {item?.unit_id?.code && item?.unit_id?.name ? '|' : <></>} {item?.unit_id?.name}</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.to_location ? item?.to_location : '-'} {item?.to_state ? item?.to_state : ''}</span>
                                                                <span className='_lgtText'> {item?.consignee_id?.code} {item?.consignee_id?.code && item?.consignee_id?.name ? '|' : <></>} {item?.consignee_id?.name}</span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.invoice_number ? item?.invoice_number : '-'}</span>
                                                                <span className='_lgtText'>Invoice Number</span>
                                                            </div>

                                                            <div>
                                                                <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span>
                                                            </div>

                                                        </div>
                                                    </td>

                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        {(item?.pod_status === 1 && item?.lr_status >= 3) ?
                                                            <div className='_lrDetails_maFx'>
                                                                <div>
                                                                    <button className='__attch_podBtn' onClick={(e) => addPodHandler(item)}> + Add POD </button>
                                                                </div>
                                                            </div> :
                                                            <div className='_lrDetails_maFx'>
                                                                <div className='_dateNtime'>
                                                                    <span className='_tblText'>{item?.pod_number ? item?.pod_number : '-'}</span>
                                                                    <span className='_lgtText'>POD Number</span>
                                                                </div>

                                                                <div className='_dateNtime'>
                                                                    <span className='_tblText'>{item?.pod_date ? moment(item?.pod_date).format('DD MMM YYYY') : '-'} {item?.pod_date && '|'} {item?.pod_date ? moment(item?.pod_date).format('hh:mm A') : ''}</span>
                                                                    <span className='_lgtText'>POD Date</span>
                                                                </div>
                                                                <div>
                                                                    {item?.pod_status ? <span className={masterData?.pod_status[item?.pod_status] === 'Pending' ? '_lrPending_status' : (masterData?.pod_status[item?.pod_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.pod_status[item?.pod_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.pod_status[item?.pod_status] === 'Received' ? '_lrDelivered_status' : (masterData?.pod_status[item?.pod_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.pod_status[item?.pod_status] ? masterData?.pod_status[item?.pod_status] : ''} </span> : '-'}
                                                                </div>
                                                                <div>
                                                                    <button className='__attch_podBtn' onClick={(e) => editPodHandler(item)}> View POD ({item?.pod_file?.length > 0 ? item?.pod_file?.length : ''}) </button>
                                                                </div>
                                                            </div>
                                                        }
                                                    </td>

                                                    <td className='_avPointer' onClick={(e) => { e.stopPropagation(); setHandleRowData(item) }}>
                                                        <div className='__freightDetails'>
                                                            <div className='__freightDetails_inr'><h6>Total Freight</h6> <p className='__inBlue'> &#x20B9; {item?.lr_freight?.total_freight ? +item?.lr_freight?.total_freight : 0}</p></div>
                                                            <div className='__freightDetails_inr'><h6>Freight Received</h6> <p> &#x20B9; {(item?.lr_freight?.advance_freight || item?.lr_freight?.pending_balance_freight) ? ((item?.lr_freight?.advance_freight ? +item?.lr_freight?.advance_freight : 0) + (item?.lr_freight?.pending_balance_freight ? +item?.lr_freight?.pending_balance_freight : 0)) : 0}</p></div>
                                                            <div className='__freightDetails_inr'><h6>Claim Receivable</h6> <p> &#x20B9; {item?.lr_freight?.pending_receivable ? +item?.lr_freight?.pending_receivable : 0}</p></div>
                                                            <div className='__freightDetails_inr'><h6>Claim Received</h6> <p> &#x20B9; {(item?.lr_freight?.receivable || item?.lr_freight?.pending_receivable) ? (item?.lr_freight?.receivable - item?.lr_freight?.pending_receivable) : 0}</p></div>
                                                            <div className='__freightDetails_inr'><h6>Claim Payable</h6> <p> &#x20B9; {item?.lr_freight?.pending_payble ? +item?.lr_freight?.pending_payble : 0}</p></div>
                                                            <div className='__freightDetails_inr'><h6>Claim Paid</h6> <p> &#x20B9; {(item?.lr_freight?.payble || item?.lr_freight?.pending_payble) ? ((item?.lr_freight?.payble ? (+item?.lr_freight?.payble) : 0) - (item?.lr_freight?.pending_payble ? +item?.lr_freight?.pending_payble : 0)) : 0}</p></div>
                                                            <div className='__freightDetails_inr'><h6>Balance</h6> <p> &#x20B9; {item?.lr_freight?.balance ? +item?.lr_freight?.balance : 0}</p></div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            {/* <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.lr_process[0]?.date ? utils?.formateDateCalander(item?.lr_process[0]?.date) : '-'} {item?.lr_process[0]?.date && '|'} {item?.lr_process[0]?.date ? moment(item?.lr_process[0]?.date).format('hh:mm A') : ''}</span>
                                                                <span className='_lgtText'>At Party Point</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.lr_process[3]?.date ? utils?.formateDateCalander(item?.lr_process[3]?.date) : '-'} {item?.lr_process[3]?.date && '|'} {item?.lr_process[3]?.date ? moment(item?.lr_process[3]?.date).format('hh:mm A') : ''}</span>
                                                                <span className='_lgtText'>Delivered Time</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'> {(item?.lr_process[0]?.date && item?.lr_process[3]?.date) ? utils?.newGetDuration(item?.lr_process[0]?.date, item?.lr_process[3]?.date) : '-'} </span>
                                                                <span className='_lgtText'>Hault Time</span>
                                                            </div> */}
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{utils.getTotalAmount(item?.lr_material_list, 'qty')} </span>
                                                                <span className='_lgtText'>QTY</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{utils.getTotalAmount(item?.lr_material_list, 'kot')}</span>
                                                                <span className='_lgtText'>KOT</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{utils.getTotalAmount(item?.lr_material_list, 'weight')} TON</span>
                                                                <span className='_lgtText'>Weight</span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td onClick={(e) => e.stopPropagation()}>
                                                        <div className='_lrDetails_maFx' onClick={(e) => setShowVehicleDetails(item)}>
                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>
                                                                    <a className='_avPointer'> {item?.trip_id?.vehicle_id?.vehicle_no ? item?.trip_id?.vehicle_id?.vehicle_no : '-'} </a>
                                                                    {/* {item?.trip_id?.vehicle_id?.vehicle_no ? item?.trip_id?.vehicle_id?.vehicle_no : '-'} */}
                                                                </span>
                                                                <span className='_lgtText'>{item?.trip_id?.lorry_type_id?.lorry_type ? item?.trip_id?.lorry_type_id?.lorry_type : ''} {item?.trip_id?.vehicle_type_id?.name ? item?.trip_id?.vehicle_type_id?.name : ''}</span>
                                                            </div>

                                                            {/* <div className='_dateNtime'>
                                                            <span className='_tblText'>{item?.pod_date ? moment(item?.pod_date).format('DD/mm/yy') : '-'} {item?.pod_date && '|'} {item?.pod_date ? moment(item?.pod_date).format('hh:mm A') : ''}</span>
                                                            <span className='_lgtText'>POD Date</span>
                                                        </div> */}

                                                            <div>
                                                                {item?.vehicle_ownership ? <span className={item?.vehicle_ownership === 2 ? '_lrPending_status' : '_lrInTransit_status'}>{masterData?.vehicle_ownership[item?.vehicle_ownership]}</span> : '-'}
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='_lrDetails_maFx'>
                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'> {item?.plan_id?.indent_date ? utils.customizeDate(item?.plan_id?.indent_date) : '-'} </span>
                                                                <span className='_lgtText'>Indent Date</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.indent_number ? item?.indent_number : '-'}</span>
                                                                <span className='_lgtText'>Indent Number</span>
                                                            </div>

                                                            <div className='_dateNtime'>
                                                                <span className='_tblText'>{item?.po_number ? item?.po_number : '-'}</span>
                                                                <span className='_lgtText'>PO Number</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        :
                                        <tr>
                                            <td colSpan={3}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                    }
                </div>
                {detailsData?.length > 0 &&
                    <>
                        <div className="_mainPaginate_ft">
                            <div className="_rcl_bx">
                                {/* <p>0 of 81 row(s) selected.</p> */}
                                <p>{`Rows ${startRow} to ${endRow} of ${totalRecords} row(s) selected.`}</p>
                                {/* <button className='_mngBtn'>Manage Column</button> */}
                            </div>
                            <div className="pagination_">
                                <button
                                    className="_nxRev_btn"
                                    disabled={currentPage === 1}
                                    onClick={() => onPageChange(currentPage - 1)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="8"
                                        height="12"
                                        viewBox="0 0 8 12"
                                        fill="none"
                                    >
                                        <path
                                            d="M6.31348 1L1.40756 5.88384L6.34488 10.7359"
                                            stroke="#000"
                                            strokeWidth="1.63965"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </button>

                                {renderPagination()}

                                <button
                                    className="_nxRev_btn nxtPage_btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => onPageChange(currentPage + 1)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="8"
                                        height="12"
                                        viewBox="0 0 8 12"
                                        fill="none"
                                    >
                                        <path
                                            d="M6.31348 1L1.40756 5.88384L6.34488 10.7359"
                                            stroke="#000"
                                            strokeWidth="1.63965"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </>}
            </div >
        </>
    )
}

export default BillRaiseDetailsLrList